<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row>
                    <lg-form-input v-model="form.descricao" label="Descrição:" cols="12" sm="8" md="10" />
                    <lg-form-const-select label="Situação:" cols="12" sm="4" md="2" v-model="form.situacao"
                        :options="form.optionsFilterSituacao" @change="load" />
                </b-form-row>
                <b-form-row>
                    <b-col cols="12" class="text-right">
                        <b-button id="localizarTipoEstado" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizarTipoEstado" title="Localizar"></b-tooltip>

                        </b-button>
                        <b-button v-if="temPrivilegioCriacao()" id="novoTipoEstado" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill @click="abrirModalTipoEstadoConservacao(null)" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novoTipoEstado" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" @row-dblclicked="estadoConservacaoSelect" show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switchGrupo'">
                            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="row.item.situacao"
                                @change="alteraSituacao(row.item)" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>
                    <template v-slot:cell(action)="row">

                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button'" class="my-2"
                            size="sm" pill variant="primary" @click="abrirModalTipoEstadoConservacao(row.item.id)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>

                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                            totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
                <TipoEstadoConservacaoForm v-if="showModalTipoEstadoConservacao" @close="cancelar" :isModal="isModal"
                    :id="id" :prefix="updatedPrefix" />
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import ConfirmMixin from "@/core/mixins/confirm"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import TipoEstadoConservacaoForm from "./TipoEstadoConservacaoForm.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        TipoEstadoConservacaoForm
    },
    props: {
        isModal: Boolean,
        prefix: {
            type: Array,
            default: () => [],

        }
    },
    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            showModalTipoEstadoConservacao: false,
            id: null,
            filtro: "",
            form: {
                descricao: "",
                situacao: "1",
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/tipo-estado-conservacao`);
    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Estado de Conservação"];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },

        tableFields() {
            return [
                { key: "descricao", label: "Descrição" },
                { key: "situacao", label: " ", tdClass: "w-1" },
                { key: "action", label: "  ", tdClass: "w-1" },
            ];
        },
    },
    methods: {

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

        },
        async load() {
            let filtro = {}
            if (this.form.descricao && this.form.descricao != "") {
                filtro.descricao = this.form.descricao;
            }
            if (this.form.situacao != undefined) {
                filtro.situacao = this.form.situacao;
            }
            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });
        },
        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Tipo de Estado Conservação?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },
        abrirModalTipoEstadoConservacao(id) {
            this.id = id;
            this.showModalTipoEstadoConservacao = true;
        },
        cancelar() {
            this.showModalTipoEstadoConservacao = false;
            this.load();
        },
        async estadoConservacaoSelect(item) {
            this.$emit("onDblClickEstadoConservacao", item);
        },
    },
};
</script>
